import React, { useState } from 'react';
import Login from './Login';
import AdminDashboard from './AdminDashboard';

const AdminPage = () => {
  const [token, setToken] = useState(() => sessionStorage.getItem('admin_token'));

  const handleLogout = () => {
    sessionStorage.removeItem('admin_token');
    setToken(null);
  };

  if (!token) return <Login onLogin={setToken} />;
  return <AdminDashboard token={token} onLogout={handleLogout} />;
};

export default AdminPage;
